// 文档： https://gitlab.xunlei.cn/acc-base/login-ui/tree/master/packages/utilities
import config from '../xbase-sdk.config'

const apiOrigins = ['https://xluser-ssl.xunlei.com', 'https://xluser2-ssl.xunlei.com', 'https://xluser3-ssl.xunlei.com']

export default process.client
  ? (async () => {
    const { checkCanUseNativeApi, createNativeApi } = require('@xunlei/xluser-utilities/dist/native-api')
    const { XLDeviceSignUtil } = require('@xunlei/xluser-utilities/dist/device-sign-util')
    // const { deviceSign2DeviceId } = require('@xbase/device-sign-utility')
    const { isIOSNative } = await import('@xunlei/universal-native-api')
    if (isIOSNative) return {}
    // 创建native api
    const deviceSignUtil = new XLDeviceSignUtil()
    const consumerContext = {
      project_id: 'pan.xunlei.com',
      client_id: config.clientId,
    }
    // 创建native api
    let nativeApi
    if (checkCanUseNativeApi()) {
      nativeApi = createNativeApi()
      await nativeApi.init()
      await nativeApi.getAppInfo()
    }
    // 在Web环境中使用本地的deviceSign数据，无法通过服务端校验，仅限于海外项目未部署deviceSign服务时使用。
    const enableLocalDeviceSignInWeb = false
    // 自定义device sign的key值前缀，使用默认值则传undefined
    const preSectionName = undefined
    // 初始化
    await deviceSignUtil.init(
      consumerContext,
      apiOrigins,
      nativeApi,
      enableLocalDeviceSignInWeb,
      preSectionName || undefined,
    )
    // 获取devicesign
    const deviceSign = deviceSignUtil.getDeviceSign()
    // devicesign转deviceid
    // const deviceID = deviceSign2DeviceId(deviceSign)
    return {
      deviceSign,
      deviceID: '',
    }
  })()
  : {}
